<template>
    <drawer-layout>
        <v-card flat>
            <v-card-title>
                <v-icon large left>mdi-wrench-clock</v-icon>
                <span class="text-h6">Dashboard is under construction</span>
            </v-card-title>
        </v-card>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout.vue";

export default {
    components: { DrawerLayout},
}
</script>

<style scoped>

</style>
